import { defineMessages } from 'react-intl';

export const resultCountMessages = defineMessages({
  numberOfSearches: {
    id: 'resultCount.numberOfSearches',
    defaultMessage: 'Number of searches: <b>{count}</b>',
  },
  numberOfRecords: {
    id: 'resultCount.numberOfRecords',
    defaultMessage: 'Number of records: <b>{count}</b>',
  },
  numberOfItems: {
    id: 'resultCount.numberOfItems',
    defaultMessage: 'Number of items: <b>{count}</b>',
  },
  numberOfProjects: {
    id: 'resultCount.numberOfProjects',
    defaultMessage: 'Number of projects: <b>{count}</b>',
  },
});
